module.exports = __webpack_public_path__ + "img/QRCode.fd1be249.png";